
export const getToken = () => localStorage.getItem("authToken");

// Store the token in localStorage
export const setToken = (token) => {
  localStorage.setItem("authToken", token);
};

// Remove the token from localStorage
export const clearToken = () => {
  localStorage.removeItem("authToken");
};
